<template>
<div id="app">
  <notifications />
  <div v-if="showToast" class="toast">
    {{ toastMessage }}
  </div>
  <router-view/>


  </div>
</template>

<script>


export default {
  name: 'App',

};
</script>


<style>
.divider:after,
.divider:before {
content: "";
flex: 1;
height: 1px;
background: #eee;
}
.h-custom {
height: calc(100% - 73px);
}
@media (max-width: 450px) {
.h-custom {
height: 100%;
}
}
</style>
